'use client';
import { useEffect } from 'react';
import { isNotTestOrProduction } from '../../core/utilities/env.utils.js';
import { styleKeyVarMap } from '../../core/utilities/style-keys.utils.js';

let r = new Set();
function useComponentStylesLoaded(l, n) {
    useEffect(()=>{
        let e = null === n ? [] : Array.isArray(n) ? n : [
            n
        ];
        l && e.length > 0 && !r.has(l) && isNotTestOrProduction() && (r.add(l), setTimeout(()=>{
            let t = [];
            e.forEach((e)=>{
                let r = styleKeyVarMap[e];
                r.length > 0 && !getComputedStyle(document.documentElement).getPropertyValue(r) && t.push(e);
            }), t.length && console.warn(`${l} is missing the required style key(s): ${t.join(', ')}`);
        }, 3000));
    }, []);
}

export { useComponentStylesLoaded };
